"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

var _typeof = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/typeof.js");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es7.array.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.string.pad-start");

require("core-js/modules/es6.number.constructor");

var _data = require("@/api/data");

var _cmsWorkOrder = _interopRequireWildcard(require("@/api/cmsWorkOrder"));

var _followInfo = _interopRequireDefault(require("@/api/followInfo"));

var _request = _interopRequireDefault(require("@/utils/request"));

var _multiUserSelect = _interopRequireDefault(require("@/views/cms/common/multiUserSelect"));

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'FollowInfo',
  components: {
    UserSelect: _multiUserSelect.default,
    CommonUpload: _commonUpload.default
  },
  props: {
    followCustService: {
      type: String,
      default: ''
    },
    custAllotUser: {
      type: String,
      default: ''
    },
    custId: {
      type: Number,
      required: true
    }
  },
  computed: {
    imgPreviewPrefix: function imgPreviewPrefix() {
      return this.$store.getters.imgPreviewPrefix;
    },
    filePreviewPrefix: function filePreviewPrefix() {
      return this.$store.getters.filePreviewPrefix;
    }
  },
  data: function data() {
    return {
      url: 'api/followInfo/get',
      form: {
        followUser: '',
        followTime: new Date(),
        callDuration: '',
        followType: '',
        step: '',
        createdAt: '',
        creator: '',
        content: '',
        followImgs: []
      },
      configLoading: false,
      followList: [],
      reverse: false,
      showFollowDialog: false,
      showUserSelect: false
    };
  },
  methods: {
    init: function init(custId, followId) {
      var _this2 = this;

      // 类似旧版本 followInfo 组件的 init 方法
      // 重置表单数据
      this.form = {
        followUser: '',
        followTime: new Date(),
        callDuration: '',
        followType: '',
        step: '',
        content: '',
        image: []
      }; // 获取跟进记录

      if (custId) {
        // 使用cmsWorkOrder中的getCustFollowList方法来获取跟进记录
        _cmsWorkOrder.default.getCustFollowList({
          custId: custId,
          page: 0,
          size: 10,
          sort: 'createTime,desc'
        }).then(function (res) {
          var content = res.content;
          console.log('获取到的跟进记录:', content); // 限制跟进记录为10条

          _this2.followList = content;
        }).catch(function (err) {
          console.error('获取跟进记录失败:', err);
        });
      }
    },
    // 新增跟进
    openAddFollowDialog: function openAddFollowDialog() {
      var _this3 = this;

      // 先显示新增跟进弹窗
      this.showFollowDialog = true; // 在下一个事件循环中设置跟进时间为当前时间

      this.$nextTick(function () {
        _this3.form.followTime = new Date();
        console.log('当前时间:', _this3.form.followTime);
      });
    },
    doSubmit: function doSubmit() {
      var _this = this;

      _this.configLoading = true;

      _this.$refs['followForm'].validate(function (valid) {
        if (valid) {
          _this.configLoading = false; // 构建请求体
          // 将Date对象转换为字符串格式

          var followTimeStr = _this.form.followTime;

          if (_this.form.followTime instanceof Date) {
            var year = followTimeStr.getFullYear();
            var month = String(followTimeStr.getMonth() + 1).padStart(2, '0');
            var day = String(followTimeStr.getDate()).padStart(2, '0');
            var hours = String(followTimeStr.getHours()).padStart(2, '0');
            var minutes = String(followTimeStr.getMinutes()).padStart(2, '0');
            var seconds = String(followTimeStr.getSeconds()).padStart(2, '0');
            followTimeStr = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
          }

          var requestData = {
            custId: _this.custId,
            followName: _this.form.followUser,
            followTime: followTimeStr,
            followType: _this.form.followType,
            callDuration: _this.form.callDuration,
            image: _this.form.image,
            step: _this.form.step,
            followContent: _this.form.content,
            status: 1,
            remark: ''
          }; // 发送POST请求到/api/custFollow

          (0, _request.default)({
            url: '/api/custFollow',
            method: 'post',
            data: requestData
          }).then(function (res) {
            _this.$emit('save', _this.form); // 提交成功后关闭弹窗


            _this.showFollowDialog = false; // 刷新跟进记录

            _this.init(_this.custId);
          }).catch(function (err) {
            _this.configLoading = false;
            console.error('保存跟进信息失败:', err);
          });
        } else {
          return false;
        }
      });
    },
    // 处理文件上传成功
    uploadImgs: function uploadImgs(filePaths) {
      var _this4 = this;

      this.form.image = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 直接将接口返回的数据包添加到form.image中，而不是构建路径

          _this4.form.image.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);
        }
      });
    },
    // 处理文件删除成功
    delImg: function delImg(filePaths) {
      var _this5 = this;

      this.form.image = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath); // 直接将接口返回的数据包添加到form.image中，而不是构建路径

          _this5.form.image.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);
        }
      });
    },
    // 根据索引删除文件
    delImgIndex: function delImgIndex(index) {
      this.form.image.splice(index, 1);
    },
    // 打开用户选择弹窗
    onUserSelect: function onUserSelect(type) {
      this.showUserSelect = true;
      this.$refs.userSelect.selectType = type; // 由于现在this.form.followUser存储的是姓名（nickNames），所以将其设置为nickNames

      this.$refs.userSelect.nickNames = Array.isArray(this.form.followUser) ? this.form.followUser : this.form.followUser ? [this.form.followUser] : []; // userNames暂时设置为空数组，因为我们现在使用nickNames作为followUser

      this.$refs.userSelect.userNames = []; // 每次打开用户选择弹窗时，重置isFirst为true，确保重新获取部门数据

      this.$refs.userSelect.isFirst = false;
      this.$refs.userSelect.getDeptDatas("爱阁工房");
    },
    // 关闭用户选择弹窗
    onUserSelectClose: function onUserSelectClose() {
      this.showUserSelect = false;
    },
    // 重置表单
    resetForm: function resetForm() {
      // 重置表单数据
      var now = new Date();
      var year = now.getFullYear();
      var month = String(now.getMonth() + 1).padStart(2, '0');
      var day = String(now.getDate()).padStart(2, '0');
      var hours = String(now.getHours()).padStart(2, '0');
      var minutes = String(now.getMinutes()).padStart(2, '0');
      var seconds = String(now.getSeconds()).padStart(2, '0');
      this.form = {
        followUser: '',
        followTime: new Date(),
        callDuration: '',
        followType: '',
        step: '',
        content: '',
        image: []
      };
    },
    // 处理用户选择回调
    selectUserCallBack: function selectUserCallBack(user) {
      this.form.followUser = user.nickNames;
      this.showUserSelect = false;
    },
    // 处理JSON字符串格式的image字段，将其转换为数组
    getActivityImages: function getActivityImages(image) {
      if (!image) {
        return [];
      } // 如果是字符串，尝试解析为JSON


      if (typeof image === 'string') {
        try {
          return JSON.parse(image);
        } catch (e) {
          console.error('解析image字符串失败:', e);
          return [];
        }
      } // 如果是数组，直接返回


      if (Array.isArray(image)) {
        return image;
      }

      return [];
    },
    // 处理JSON字符串格式的followName字段，将其转换为数组
    getActivityFollowNames: function getActivityFollowNames(followName) {
      if (!followName) {
        return [];
      } // 如果是字符串，尝试解析为JSON


      if (typeof followName === 'string') {
        try {
          var parsed = JSON.parse(followName); // 确保返回的是数组

          return Array.isArray(parsed) ? parsed : [parsed];
        } catch (e) {
          // 如果解析失败，将整个字符串作为一个元素返回
          return [followName];
        }
      } // 如果是数组，直接返回


      if (Array.isArray(followName)) {
        return followName;
      } // 其他情况，将其作为一个元素返回


      return [followName];
    },
    // 判断文件是否为图片
    isImage: function isImage(file) {
      // 如果file是对象，优先判断type属性
      if (file && file.type) {
        return file.type === 'image' || file.type === '图片';
      }

      var imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp']; // 如果file是字符串，直接判断扩展名

      if (typeof file === 'string') {
        var fileExtension = file.substring(file.lastIndexOf('.'));
        return imgExtensions.includes(fileExtension.toLowerCase());
      } // 如果file是对象，判断realName的扩展名


      if (file && file.realName) {
        var _fileExtension = file.realName.substring(file.realName.lastIndexOf('.'));

        return imgExtensions.includes(_fileExtension.toLowerCase());
      }

      return false;
    },
    // 获取文件名
    getFileName: function getFileName(file) {
      // 如果file是字符串，返回最后一个斜杠后的部分
      if (typeof file === 'string') {
        return file.split('/').pop();
      } // 如果file是对象，返回realName


      if (file && file.realName) {
        return file.realName;
      }

      return '';
    },
    // 处理文件预览或下载
    handleFilePreview: function handleFilePreview(file) {
      // 构建文件URL
      var fileUrl = this.getFileUrl(file); // 判断文件类型

      if (!this.isImage(file)) {
        // 文件类型，在新窗口打开
        window.open(fileUrl, '_blank');
      } // 图片类型由el-image的预览功能处理，不需要额外操作

    },
    // 根据file的type来使用对应前缀构建文件URL
    getFileUrl: function getFileUrl(file) {
      // 如果file是字符串，直接返回
      if (typeof file === 'string') {
        return file;
      } // 优先使用文件自带的完整URL（OSS直传）


      if (file.url) return file.url; // 如果file是对象，根据type来使用对应前缀

      if (file && file.type && file.realName) {
        if (file.type === 'image' || file.type === '图片') {
          return this.imgPreviewPrefix + file.realName;
        } else {
          return this.filePreviewPrefix + file.realName;
        }
      }

      return '';
    }
  }
};
exports.default = _default;